<template>
	<div class="dg-card">
		<div class="dg-card-head">
			<h3><span v-text="$t('dashboard_gestao_problemas_titulo')"></span></h3>
			<span class="dg-hint" :title="$t('dashboard_gestao_problemas_tooltip')">
				<i class="fas fa-info-circle"></i>
			</span>
		</div>
		<div class="chart-wrap">
			<apexchart
				type="bar"
				height="210"
				:options="chartOptions"
				:series="chartSeries"
			></apexchart>
		</div>
		<div class="prob-legend">
			<span class="legend-item"><span class="legend-dot legend-dot--crit"></span><span v-text="$t('dashboard_gestao_legenda_criticos')"></span></span>
			<span class="legend-item"><span class="legend-dot legend-dot--med"></span><span v-text="$t('dashboard_gestao_legenda_medios')"></span></span>
			<span class="legend-item"><span class="legend-dot legend-dot--low"></span><span v-text="$t('dashboard_gestao_legenda_baixos')"></span></span>
		</div>
	</div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import DashboardGestaoController from '@/views/controllers/DashboardGestaoController';

export default {
	name: 'DashboardGestaoProblemas',
	components: { apexchart: VueApexCharts },
	props: {
		cur: { type: Array, default: () => [] },
	},
	computed: {
		chartSeries() {
			return DashboardGestaoController.getIssuesChartData(this.cur).series;
		},
		chartOptions() {
			return DashboardGestaoController.getIssuesChartOptions(this.cur);
		},
	},
};
</script>

<style scoped lang="less">
@card: #ffffff;
@line: #e7e9f0;
@ink: #1a2036;
@muted: #6b7280;
@red: #dc2626;
@amber: #f59e0b;

.dg-card {
	background: @card;
	border-radius: 14px;
	border: 1px solid @line;
	box-shadow: 0 1px 2px rgba(20, 29, 56, 0.04);
}

.dg-card-head {
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 16px 18px 4px;

	h3 {
		margin: 0;
		font-size: 14.5px;
		font-weight: 700;
		color: @ink;
		letter-spacing: -0.2px;
	}

	.dg-hint {
		display: inline-flex;
		color: @muted;
		cursor: help;
	}
}

.chart-wrap {
	padding: 6px 10px 14px;
}

.prob-legend {
	display: flex;
	gap: 18px;
	padding: 0 18px 16px;
	font-size: 12px;
	color: @muted;

	.legend-item {
		display: inline-flex;
		align-items: center;
		gap: 6px;
	}

	.legend-dot {
		width: 11px;
		height: 11px;
		border-radius: 3px;

		&--crit { background: @red; }
		&--med { background: @amber; }
		&--low { background: #e9c94a; }
	}
}
</style>
